// extracted by mini-css-extract-plugin
export default {"title_wrapper":"Form_title_wrapper__YVVIG","form_wrapper":"Form_form_wrapper__H3MHg","btn_wrapper":"Form_btn_wrapper__Vt4R-"};